import React, { Component } from 'react';

import Input from '../Input';
import { __ } from '../../lib/I18n';
import { validateEmail } from '../../lib/Util';

/**
 * @typedef {{
 *  value: string,
 *  onChange: (email: string) =>void,
 *  onConfirm: () => void
 * }} Props
 * @extends {Component<Props>}
 */
export default class EmailInput extends React.Component {
  /** @param {Props} props */
  constructor(props) {
    super(props);

    this.state = {
      error: null
    };
  }

  /**
   * @param {string} email
   * @returns {boolean}
   */
  validate = (email) => {
    if (!validateEmail(email)) {
      this.onError();
      return false;
    }

    return true;
  };

  onConfirm = () => {
    const { value, onConfirm } = this.props;

    if (this.validate(value) && onConfirm) onConfirm();
  };

  onError = () => {
    this.setState({ error: 'Não foi possível encontrar sua conta no ClassApp' });
  };

  render() {
    const { error } = this.state;
    const { value, onChange } = this.props;

    return (
      <div className="input-component" style={{ marginBottom: '2.5rem' }}>
        <h5 style={{ marginBottom: '.5rem', marginLeft: '1rem' }}>{__('Email')}</h5>
        <Input
          placeholder="email@email.com"
          type="email"
          value={value}
          error={error}
          onChange={/** @param {any} e */(e) => onChange(e.target.value)}
          onKeyPress={() => this.onConfirm()}
          style={{ width: '23rem' }}
        />
      </div>
    );
  }
}
